import {
  FETCH_LOAD_TEMPLATE_BY_ID_REQUEST,
  FETCH_LOAD_TEMPLATE_BY_ID_SUCCESS,
  FETCH_LOAD_TEMPLATE_BY_ID_FALUIRE,
} from './loadTemplateOrFolderByIDTypes'

const initialState = {
  loading: false,
  particularTemplateOrFolderInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_TEMPLATE_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_TEMPLATE_BY_ID_SUCCESS : return {
      ...state,
      particularTemplateOrFolderInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_TEMPLATE_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      particularTemplateOrFolderInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
